import {Component, Input} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {I18nMessage} from '@app/shared/api/model/i18n';
import {AceValidators} from '@app/shared/util/validators/ace-validators';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

interface IntervalPromptModalData {
  message: I18nMessage;
}

@Component({
  selector: 'app-interval-prompt-modal',
  standalone: false,
  templateUrl: './interval-prompt-modal.component.html'
})
export class IntervalPromptModalComponent implements IntervalPromptModalData {
  exportDataIntervalControl = new FormControl<number>(null, {validators: [Validators.required, AceValidators.min(1)]});
  @Input() message: I18nMessage;
  constructor(public activeModal: NgbActiveModal) {}

  submit(interval: number): void {
    this.activeModal.close(interval);
  }

  cancel(): void {
    this.activeModal.dismiss('User cancel');
  }

  static open(modalService: NgbModal, modalData: IntervalPromptModalData, modalOptions?: NgbModalOptions): NgbModalRef {
    const modalRef = modalService.open(IntervalPromptModalComponent, {
      size: 'sm',
      centered: true,
      ...modalOptions
    });
    const component: IntervalPromptModalComponent = modalRef.componentInstance;
    component.message = modalData.message;
    return modalRef;
  }
}
